export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фільтри"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статус"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Магазин"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Застосувати"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Очистити все"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть статус"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть магазин"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть номер рахунку"])}
}